
export default {
  name: 'HomepageWelcome'
}
